import { useAppSelector } from '../reducers';
import { isUngatedForCommerceHubInbound25Selector, isUngatedForInbound25Selector, isUngatedForSeatsSelector } from '../selectors/GatingSelectors';

/**
 * This hook is used to determine if the Commerce Hub product experience or payments experience should be shown.
 * The Commerce Hub product experience is the new Commerce Hub page with Merch Cards.
 * The Commerce Hub payments experience is the old/existing HubSpot and Stripe Payments page.
 */
export const useCommerceHub = () => {
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const isUngatedForCommerceHubInbound25 = useAppSelector(isUngatedForCommerceHubInbound25Selector);

  // when ungated, show new commerce hub page only for the seats cohort, this is the Commerce Hub page with Merch Cards
  // for the public app, we always show the new commerce hub page when ungated
  const showCommerceHubProductExperience = isUngatedForCommerceHubInbound25 && isUngatedForSeats;

  // only show payments experience when the inbound gate is not enabled, this is the HubSpot and Stripe Payments page
  const showCommerceHubPaymentsExperience = !isUngatedForInbound25;
  return {
    showCommerceHubProductExperience,
    showCommerceHubPaymentsExperience
  };
};